import { gql } from "@apollo/client";

export const UPSERT_CLIENT_SETTING = gql`
  mutation UpsertMMMClientSetting($data: ClientSettingFormShape!) {
    upsertMMMClientSetting(data: $data) {
      clientSetting {
        id
        cycle_id
        client_setting_date_range {
          id
          start_date
          end_date
        }
        reference_start_date
        reference_end_date
        client_id
        spend_constraints {
          id
          feature {
            id
            column_name
            is_from_mta
            mta_breakdowns {
              key
              value
            }
            friendly_name
          }
          feature_v2 {
            id
            column_name
            is_from_mta
            mta_breakdowns {
              key
              value
            }
            friendly_name
          }
          budget_low
          budget_high
        }
        # mix_validations {
        #   id
        #   feature {
        #     id
        #     column_name
        #     is_from_mta
        #     mta_breakdowns {
        #       key
        #       value
        #     }
        #     friendly_name
        #   }
        #   percentage_low
        #   percentage_high
        # }
        kpi {
          equation
          kpi_name
          id
          friendly_name
          kpi_type
          data_columns
          is_active
          is_default_kpi
          kpi_name
        }
        kpi_v2 {
          equation
          kpi_name
          id
          friendly_name
          kpi_type
          data_columns
          is_active
          is_default_kpi
          kpi_name
        }
        name
        budget_low
        budget_high
        desired_kpi_value
        target_spend
        profit_value_per_unit_kpi
        max_cost_per_unit_kpi
      }
    }
  }
`;
